import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';

import { CartContext } from '../../contexts/CartContext';

import { CreditCard } from './creditcard.component';
import { Loading } from './loading.component';
import { EditModalProps } from './payment-method.component';

export const EditCreditCard = ({
    openEditModal,
    setEditModalIsOpen,
    selectedCreditCard,
    setOpenParentModal,
    setCheckoutStep,
}: EditModalProps) => {
    const { t } = useTranslation();
    const { setSubmitCreditCard } = useContext(CartContext);

    const closeModal = () => {
        setEditModalIsOpen(false);
        setOpenParentModal(true);
    };

    const editCartCreditCard = () => {
        setSubmitCreditCard('edit');
    };

    Modal.setAppElement('#expressCheckout');
    return (
        <>
            <Modal
                isOpen={openEditModal}
                contentLabel="Edit Payment Card"
                className="modal__contentwrap"
                overlayClassName="modal__overlay"
            >
                <div className="modal__header">
                    <button className="modal__button-back" onClick={closeModal}>
                        {t('Back')}
                    </button>
                    <h3>
                        {t('Edit Credit Card')}
                        {/* {selectedCreditCard.Type + ' ending in ' + selectedCreditCard.Number.substr(12, 4)} */}
                    </h3>

                    <button className="modal__button-close" onClick={closeModal}>
                        {t('Close')}
                    </button>
                </div>
                <div className="modal__body">
                    <CreditCard
                        setCheckoutStep={setCheckoutStep}
                        selectedCreditCard={selectedCreditCard}
                        setAddModalIsOpen={null}
                        setEditModalIsOpen={setEditModalIsOpen}
                        setOpenParentModal={setOpenParentModal}
                        showPayPal={false}
                    />
                </div>

                <div className="modal__footer">
                    <Loading />
                    <button className="modal__button--save button" onClick={editCartCreditCard}>
                        {t('Save & Continue')}
                    </button>
                </div>
            </Modal>
        </>
    );
};
